import React from 'react';
import UserProfileProvider from 'auth/contexts/UserProfileContext';
import EkgRecordingDetails from 'views/pages/EkgRecordingDetails';
import ContentWithNavigationSidebar from '../legacy/layouts/ContentWithNavigationSidebar';
import EkgReviewEkgRecording from '../legacy/pages/EkgReviewEkgRecording';
import EkgReview from '../legacy/pages/EkgReview';
import QtEkgReview from '../legacy/pages/QtEkgReview';
import ROUTE_PATHS from './routePaths';

const routes = [
  {
    exact: true,
    authenticatedRoute: true,
    path: `${ROUTE_PATHS.EKG_REVIEW_EKG_RECORDING}/:recordingId`,
    component: props => (
      <ContentWithNavigationSidebar>
        <EkgReviewEkgRecording {...props} />
      </ContentWithNavigationSidebar>
    ),
  },

  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.EKG_REVIEW,
    component: props => (
      <ContentWithNavigationSidebar>
        <EkgReview {...props} />
      </ContentWithNavigationSidebar>
    ),
  },

  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.QT_EKG_REVIEW,
    component: props => (
      <ContentWithNavigationSidebar>
        <QtEkgReview {...props} />
      </ContentWithNavigationSidebar>
    ),
  },

  {
    exact: true,
    authenticateRoute: true,
    path: ROUTE_PATHS.EKG_RECORDING,
    // component: React.lazy(() => import('views/pages/EkgRecording')),
    component: props => (
      <UserProfileProvider>
        <EkgRecordingDetails {...props} />
      </UserProfileProvider>
    ),
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/ecgRoutes.jsx